import React from 'react';
import {
  ChevronDownIcon,
  ChevronUpIcon
} from '@heroicons/react/24/outline';

const ServiceImpactSummary = ({ serviceStats, isExpanded, toggleExpand }) => {
  const serviceBoxes = [
    {
      title: "Volunteers Participated",
      subtitle: "Total Volunteers Involved",
      count: serviceStats.volunteersParticipated,
      label: "Volunteers",
      bgColor: "#F0FDF4",
      textColor: "#1EA550",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
        </svg>
      )
    },
    {
      title: "Service Hours",
      subtitle: "Total Hours Rendered",
      count: serviceStats.serviceHours,
      label: "Hours",
      bgColor: "#F0FDFA",
      textColor: "#0D9488",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
        </svg>
      )
    },
    {
      title: "Programs Completed",
      subtitle: "Total Programs Completed",
      count: serviceStats.programsCompleted,
      label: "Programs",
      bgColor: "#F0FDF4",
      textColor: "#1EA550",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
        </svg>
      )
    },
    {
      title: "Upcoming Programs",
      subtitle: "Total Number of Scheduled Programs",
      count: serviceStats.upcomingPrograms,
      label: "Programs",
      bgColor: "#F5F3FF",
      textColor: "#993EEB",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M15.59 14.37a6 6 0 0 1-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 0 0 6.16-12.12A14.98 14.98 0 0 0 9.631 8.41m5.96 5.96a14.926 14.926 0 0 1-5.841 2.58m-.119-8.54a6 6 0 0 0-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 0 0-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 0 1-2.448-2.448 14.9 14.9 0 0 1 .06-.312m-2.24 2.39a4.493 4.493 0 0 0-1.757 4.306 4.493 4.493 0 0 0 4.306-1.758M16.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" />
        </svg>
      )
    },
    {
      title: "Upcoming Programs Hours",
      subtitle: "Total Number of Service Hours",
      count: serviceStats.upcomingProgramsHours,
      label: "Hours",
      bgColor: "#FFF6EA",
      textColor: "#EA580C",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z" />
        </svg>
      )
    },
    {
      title: "Upcoming Program Volunteers",
      subtitle: "Total Count of Registered Individuals",
      count: serviceStats.upcomingProgramVolunteers,
      label: "Volunteers",
      bgColor: "#FEF2F2",
      textColor: "#DC2626",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
        </svg>
      )
    }
  ];

  return (
    <div className="mb-8">
      {/* Dashboard Header with Toggle */}
      <div className="bg-white rounded-lg shadow mb-6">
        <button
          onClick={toggleExpand}
          className="w-full px-6 py-4 flex items-center justify-between text-left transition-all duration-200 rounded-lg hover:bg-gray-50"
        >
          <div className="flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6 mr-3 text-blue-600"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
            </svg>
            <div>
              <h4 className="text-lg font-semibold text-gray-900">Service Impact Summary</h4>
              <p className="text-sm text-gray-600">Comprehensive overview of volunteer engagement and program metrics</p>
            </div>
          </div>
          <div className="flex items-center space-x-2">
            {isExpanded ? (
              <ChevronUpIcon className="w-5 h-5 text-gray-600" />
            ) : (
              <ChevronDownIcon className="w-5 h-5 text-gray-600" />
            )}
          </div>
        </button>

        {/* Collapsible Service Content */}
        {isExpanded && (
          <div className="space-y-6 p-4 animate-in slide-in-from-top duration-300">
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-6">
              {serviceBoxes.map((box, index) => (
                <div
                  key={index}
                  className="relative group rounded-lg hover:shadow-md transition-all duration-200 p-5"
                  style={{ backgroundColor: box.bgColor }}
                >
                  <div className="flex items-start justify-between mb-3">
                    <div
                      className="rounded-lg w-10 h-10 flex items-center justify-center flex-shrink-0 mr-3"
                      style={{
                        backgroundColor: `${box.bgColor}99`
                      }}
                    >
                      {React.cloneElement(box.icon, {
                        stroke: box.textColor,
                        className: "w-6 h-6"
                      })}
                    </div>
                    <div className="flex-1">
                      <h4 className="text-base font-semibold text-gray-900 leading-tight">{box.title}</h4>
                      <p className="text-gray-600 text-xs mt-1">{box.subtitle}</p>
                    </div>
                  </div>

                  <div className="flex items-baseline justify-end space-x-1 mt-4">
                    <div
                      className="text-2xl font-bold"
                      style={{ color: box.textColor }}
                    >
                      {box.count.toLocaleString()}
                    </div>
                    <div
                      className="text-xs tracking-wide font-medium"
                      style={{ color: box.textColor }}
                    >
                      {box.label}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ServiceImpactSummary;